'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function buildPlacement(placementData) {
  /*
     take pageType, pageSection and pageAction
     pageAction is optional and for clicks, such as to open modals.
     pageLoad doesn't require the action
     can take a string if using old omtag placement names
  */
  if (!placementData) {
    return '';
  } else if (typeof placementData === 'string') {
    return placementData;
  } else if ((typeof placementData === 'undefined' ? 'undefined' : _typeof(placementData)) === 'object') {
    var type = placementData.pageType,
        section = placementData.pageSection,
        action = placementData.pageAction ? ':' + placementData.pageAction : '';

    return type + ':' + section + action;
  }
}

module.exports = {
  buildPlacement: buildPlacement
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/helper.js
// module id = 909
// module chunks = 48 49 51